import Marquee from "react-fast-marquee";
import { Sparkles } from "lucide-react";

const ITEMS = [
  "Extension Ciglia",
  "Metodo UV",
  "Laminazione",
  "Hollywood Peel",
  "Elettrostimolatore",
  "Massaggi",
  "Rimozione Laser",
];

export default function EditorialMarquee() {
  return (
    <div data-testid="editorial-marquee" className="border-y border-blush-100 bg-blush-50 py-6">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="mx-8 flex items-center gap-16">
            <span className="font-serif text-2xl italic tracking-wide text-ink/70 lg:text-3xl">
              {item}
            </span>
            <Sparkles size={16} className="text-blush-500" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
